import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-detalis-evalue',
  templateUrl: './detalis-evalue.component.html',
  styleUrls: ['./detalis-evalue.component.scss']
})
export class DetalisEvalueComponent implements OnInit {

    @Input() data: any;
    @Input() btnView = true;
    @Output() btnBack = new EventEmitter();
    @Output() btnApertura = new EventEmitter();
    @Output() btnCerrar = new EventEmitter();
    @Output() btnRemitir = new EventEmitter();

    imgUrl = environment.imgUrl;

    constructor() { }

    ngOnInit() {
    }

    back() {
        this.btnBack.emit('volver');
    }

    apertura() {
        this.btnApertura.emit('apertura');
    }

    cerrar() {
        this.btnCerrar.emit('cerrar');
    }

    remitir() {
        this.btnRemitir.emit('remitir');
    }

}
